const SameDayDelivery = () => {
    return (
    <div>
     
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
         
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Same Day Delivery
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              With over 4,500 delivery vehicles on the road and a dedicated air freighter covering Karachi, Lahore and Islamabad, 
              TCS offers same-day (24 hours) documents delivery service, within the city in selected areas of Pakistan. 
              As an important service for business-to-business customers and empowered by our delivery hubs, Karachi, 
              Lahore and Islamabad regions are fully covered by the Same Day Delivery service. This service is available 
              in 11 main cities of Pakistan.
            </p>
          </div>
          <div className="flex-1 flex flex-col justify-center items-center">
          <img src="/DomesticScrollingBanner/scrolling-image2.jpg" alt="" className="rounded-md w-[100%] sm:mt-[0rem] mt-[1rem]"/>
          </div>
        </div>
      
      </div>
    </div>

    )
};
export default SameDayDelivery;